import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import { useInView } from '../hooks/useInView';
import './EarlyPilots.css';

const EarlyPilots = () => {
  const [ref, isInView] = useInView({ threshold: 0.2, triggerOnce: true });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12
      }
    }
  };

  const badgeVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 15,
        delay: 0.2
      }
    }
  };

  const buttonVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12
      }
    },
    hover: {
      scale: 1.05,
      boxShadow: '0 15px 40px rgba(16, 185, 129, 0.4)',
      transition: {
        type: 'spring',
        stiffness: 400,
        damping: 10
      }
    },
    tap: {
      scale: 0.95
    }
  };

  const arrowVariants = {
    hover: {
      x: 5,
      transition: {
        repeat: Infinity,
        repeatType: 'reverse',
        duration: 0.6
      }
    }
  };

  return (
    <section className="early-pilots">
      <motion.div
        ref={ref}
        className="pilots-container"
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.div variants={badgeVariants} className="mvp-badge">
          MVP in Development
        </motion.div>

        <motion.h2 variants={itemVariants}>
          Early Pilots Coming Soon
        </motion.h2>

        <motion.p variants={itemVariants} className="pilots-description">
          We're building Snaply with real retailers and consumers. Join our waitlist to be
          among the first to go paperless.
        </motion.p>

        <motion.a
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className="cta-button"
          href="https://pos.snaply.to"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <span>Early Access Demo</span>
          <motion.div variants={arrowVariants}>
            <FiArrowRight />
          </motion.div>
        </motion.a>
      </motion.div>
    </section>
  );
};

export default EarlyPilots;
